class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-upsell-product',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '#cart-upsell-product',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');
        document.querySelector(".js-product-count") ? document.querySelector(".js-product-count").innerHTML = `${parsedState.item_count} products in your bag` : "";
        document.querySelectorAll(".js-main-price").length > 0 ? document.querySelectorAll(".js-main-price").forEach((e) => e.innerHTML = Shopify.formatMoney(parsedState.total_price)) : '';
        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
       
        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }
        
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
        
         if(document.querySelector(".cart_upsell_products")){
           document.querySelectorAll(".js-upsell-add-to-cart").forEach((button) => {
              button.addEventListener("click", function(event) {
          
                  let free_pro = event.target.getAttribute("data-variant-id");
                  let quantity = document.querySelector(".js-quantity-custom").querySelector("input").value;
                  const cartJson = '/cart.js';
                  window.getCartDrawerJson(free_pro, quantity,cartJson);
              })
          });
          document.querySelectorAll(".js-cart-upsell-add-to-cart").forEach((button) => {
              button.addEventListener("click", function(event) {
          
                  let free_pro = event.target.getAttribute("data-variant-id");
                  let quantity = document.querySelector(".js-quantity-custom").querySelector("input").value;
                  const cartJson = '/cart.js';
          
                  window.getCartJson(free_pro, quantity,cartJson);
              })
          });
        }  
         let removeButtons = document.querySelectorAll("custom-remove"); // Adjust the selector as needed
  let cartDrawerRemoveButtons = document.querySelectorAll("custom-remove-drawer");
    if(removeButtons.length > 0){
      removeButtons.forEach((removeButton) => removeButton.addEventListener("click", removeCartProduct.bind(this),false ));
    }
    if(cartDrawerRemoveButtons.length > 0){
      cartDrawerRemoveButtons.forEach((cartDrawerRemoveButton) => cartDrawerRemoveButton.addEventListener("click",cartDrawerRemove.bind(this),false ));
    }
    function removeCartProduct(event){
      let removeButtonProp = event.target.closest(".custom-remove-button").getAttribute("data-bundle-id");
      event.target.closest(".cart_item_info").querySelector(".loading__spinner").classList.remove("hidden");
      let intervalId = setInterval(() => {
        fetch(window.Shopify.routes.root + 'cart.js')
          .then(response => {
            if (!response.ok) {
              throw new Error('Failed to fetch cart');
            }
            return response.json();
          })
          .then(cart => {
            console.log(cart)
            let updates = {};
            let hasMainProduct = false;
    
              console.log(removeButtonProp)
            cart.items.forEach(item => {
              console.log(item)
              if (removeButtonProp === item.properties._bundleId ) {
                updates[item.key] = 0;
                hasMainProduct = true;
              }
            console.log(updates)
            });
            if (hasMainProduct) {
             
              return fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates: updates })
              });
            } else {
              clearInterval(intervalId);
              
              console.log('All main_product items have been removed');
              window.location.reload();
              return Promise.reject('No items to update');
            }
          })
          .then(response => {
            if (!response.ok) {
              throw new Error('Failed to update cart');
            }
            return response.json();
          })
          .then(data => {
            console.log('Cart updated:', data);
            // Uncomment the line below to reload the page after the update
            // window.location.reload();
          })
          .catch(error => {
            if (error !== 'No items to update') {
              console.error('Error:', error);
              alert(`There was an error: ${error.message}. Please try again.`);
              clearInterval(intervalId);
            }
          });
                
      }, 2000);
    }
    function cartDrawerRemove(event){
      let removeButtonProp = event.target.closest("custom-remove-drawer").getAttribute("data-bundle-id");
      event.target.closest(".cart-item").querySelector(".cart-item__totals").classList.remove("visually-hidden");
      event.target.closest(".cart-item").querySelector(".loading__spinner").classList.remove("hidden");
        let intervalId = setInterval(() => {
          fetch(window.Shopify.routes.root + 'cart.js')
            .then(response => {
              if (!response.ok) {
                throw new Error('Failed to fetch cart');
              }
              return response.json();
            })
            .then(cart => {
              let updates = {};
              let hasMainProduct = false;
      
              cart.items.forEach(item => {
                 if (removeButtonProp === item.properties._bundleId ) {
                  updates[item.key] = 0;
                  hasMainProduct = true;
                }
              });
      
              if (hasMainProduct) {
                return fetch(window.Shopify.routes.root + 'cart/update.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify({ updates: updates })
                });
              } else {
                clearInterval(intervalId);
                console.log('All main_product items have been removed');
                fetch(`${routes.cart_url}?section_id=cart-drawer`)
                .then((response) => response.text())
                .then((responseText) => {
                    const html = new DOMParser().parseFromString(responseText, 'text/html');
                    const selectors = ['cart-drawer-items', '.cart-drawer__footer', '#cart-icon-bubble'];
                    for (const selector of selectors) {
                      const targetElement = document.querySelector(selector);
                      const sourceElement = html.querySelector(selector);
                      if (targetElement && sourceElement) {
                        targetElement.replaceWith(sourceElement);
                        
                      }
                  }
                });
                window.location.reload();
                return Promise.reject('No items to update');
              }
            })
            .then(response => {
              if (!response.ok) {
                throw new Error('Failed to update cart');
              }
              return response.json();
            })
            .then(data => {
              console.log('Cart updated:', data);
              // Uncomment the line below to reload the page after the update
              // window.location.reload();
            })
            .catch(error => {
              if (error !== 'No items to update') {
                console.error('Error:', error);
                alert(`There was an error: ${error.message}. Please try again.`);
                clearInterval(intervalId);
              }
            });
                  
        }, 2000); 
    }
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
    
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
